import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { difference, isEmpty } from 'lodash';

import { makeGetMissingMatches } from '../../../utils';

interface Input {
    missingSportEventIds: string[];
}

interface Output {}

const requestedSportEventCache: string[] = [];

const useMobileTopMatch = ({ missingSportEventIds }: Input): Output => {
    const dispatch = useDispatch();

    useEffect(() => {
        const newIds = difference(
            missingSportEventIds,
            requestedSportEventCache
        );

        if (isEmpty(newIds)) return;

        requestedSportEventCache.push(...newIds);

        dispatch(makeGetMissingMatches(newIds));

        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [dispatch, missingSportEventIds]);

    return {};
};

export default useMobileTopMatch;
